module.exports = __webpack_public_path__ + "img/36.5ef410ac.jpg";